import { render } from "./Sale.vue?vue&type=template&id=ce3cefaa&scoped=true"
import script from "./Sale.vue?vue&type=script&lang=js"
export * from "./Sale.vue?vue&type=script&lang=js"

import "./Sale.vue?vue&type=style&index=0&id=ce3cefaa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3cefaa"]])

export default __exports__